var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _ellipse, _ellipse2, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _ellipse3, _ellipse4, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _rect, _rect2, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _ellipse5, _ellipse6, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _ellipse7, _ellipse8, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _ellipse9, _ellipse0, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _ellipse1, _rect3, _path158, _rect4, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _rect5, _rect6, _path186, _path187, _path188, _path189, _path190, _rect7, _rect8, _path191, _path192, _path193, _ellipse10, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _ellipse11, _ellipse12, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _ellipse13, _ellipse14, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _ellipse15, _ellipse16, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _ellipse17, _ellipse18, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _ellipse19, _rect9, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _ellipse20, _rect0, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _ellipse21, _ellipse22, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _ellipse23, _ellipse24, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _ellipse25, _ellipse26, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _ellipse27, _ellipse28, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _ellipse29, _ellipse30, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _rect1, _path352, _rect10, _path353, _ellipse31, _ellipse32, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgError404 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 945,
  height: 459,
  viewBox: "0 0 945 459",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M60.3952 455.543C60.3952 222.688 249.283 33.9108 482.273 33.9108C715.264 33.9108 904.151 222.669 904.151 455.543H60.3952Z",
  fill: "#F0F9FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M785.964 55.7699V61.5511",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M788.857 58.6605H783.072",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M931.6 443.565H941.846H931.6Z",
  fill: "white"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M931.6 443.565H941.846",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M1.79318 443.489H14.9692H1.79318Z",
  fill: "white"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M1.79318 443.489H14.9692",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M709.895 456.941H808.554H709.895Z",
  fill: "white"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M709.895 456.941H808.554",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M821.201 456.941H834.623H821.201Z",
  fill: "white"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M821.201 456.941H834.623",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M698.307 456.846L690.972 456.941L698.307 456.846Z",
  fill: "white"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M698.307 456.846L690.972 456.941",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M800.407 335.649L813.129 347.079L826.74 340.258L834.472 341.959L840.786 322.291L823.47 313.865L796.418 323.992L800.407 335.649Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M819.575 343.848L823.507 349.214L832.222 341.449L826.74 340.258L819.575 343.848Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M827.137 323.897L825.436 309.558L840.786 322.291L834.472 341.959",
  fill: "#E1F2FF"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M827.137 323.897L825.436 309.558L840.786 322.291L834.472 341.959",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M803.469 328.413L802.524 317.36L815.851 317.795L820.615 319.401",
  fill: "#E1F2FF"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M803.469 328.413L802.524 317.36L815.851 317.795L820.615 319.401",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M812.071 338.331L816.211 326.845L820.823 329.527",
  fill: "#E1F2FF"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M812.071 338.331L816.211 326.845L820.823 329.527",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M736.89 323.104L747.949 299.393L771.2 300.848L781.068 293.801L801.749 317.7L782.429 339.937L738.27 341.902L736.89 323.104Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M758.951 300.073L761.257 290.173L778.176 295.86L771.2 300.848L758.951 300.073Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M777.079 308.273L787.76 344.83L801.749 317.7L781.068 293.801",
  fill: "#E1F2FF"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M777.079 308.273L787.76 344.83L801.749 317.7L781.068 293.801",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M745.548 331.435L750.841 347.551L769.348 338.974L775.076 333.854",
  fill: "#E1F2FF"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M745.548 331.435L750.841 347.551L769.348 338.974L775.076 333.854",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M751.692 312.335L764.433 326.032L769.31 319.476",
  fill: "#E1F2FF"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M751.692 312.335L764.433 326.032L769.31 319.476",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M364.351 456.941H463.01H364.351Z",
  fill: "white"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M364.351 456.941H463.01",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M475.657 456.941H547.832H475.657Z",
  fill: "white"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M475.657 456.941H547.832",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M352.782 456.846L316.07 456.941L352.782 456.846Z",
  fill: "white"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M352.782 456.846L316.07 456.941",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M129.678 456.941H140.245H129.678Z",
  fill: "white"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M129.678 456.941H140.245",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M118.109 456.846L81.3975 456.941L118.109 456.846Z",
  fill: "white"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M118.109 456.846L81.3975 456.941",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M891.713 370.204C899.744 372.761 906.995 377.311 912.79 383.429C925.683 397.334 936.364 441.637 886.741 441.845C845.606 442.015 844.604 440.561 840.748 427.354C838.12 418.38 838.857 388.001 857.572 375.871C869.482 368.541 878.65 370.204 878.65 370.204C878.65 370.204 870.862 358.528 876.76 352.803C883.168 352.803 884.775 361.513 884.775 361.513C884.775 361.513 887.762 352.577 890.73 352.803C893.698 353.03 896.533 356.752 891.713 370.204Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M839.935 420.855C838.045 411.692 838.782 388.114 857.572 375.966C869.482 368.635 878.65 370.298 878.65 370.298C878.65 370.298 870.862 358.622 876.76 352.898C877.667 361.834 884.907 372.924 884.907 372.924C884.907 372.924 843.602 394.764 857.799 436.669C846.343 435.97 840.407 423.236 839.935 420.855Z",
  fill: "#9ACDED"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M907.289 392.762C911.448 398.416 913.164 405.5 912.053 412.429",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M899.35 426.882C899.35 426.882 898.197 430.547 895.191 430.774",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M890.229 433.595C890.504 434.807 889.745 436.013 888.533 436.287L860.825 442.568C859.613 442.843 858.408 442.084 858.133 440.872L848.575 398.756C848.3 397.544 849.059 396.339 850.271 396.064L877.979 389.783C879.191 389.508 880.396 390.268 880.671 391.479L890.229 433.595Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M886.987 430.944L859.765 439.144L850.842 399.865L878.537 392.252L886.987 430.944Z",
  fill: "#E1F2FF"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.33263,
  ry: 6.32929,
  transform: "matrix(0.975232 -0.221184 0.221232 0.975221 868.39 407.243)",
  fill: "white"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.33263,
  ry: 6.32929,
  transform: "matrix(0.975232 -0.221184 0.221232 0.975221 867.364 406.154)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M866.495 409.614C866.495 409.614 866.495 409.746 866.495 409.765C866.287 408.046 865.172 407.555 864.604 406.516C864.475 406.155 864.475 405.761 864.604 405.401V405.288V405.08V404.966C864.912 404.412 865.28 403.892 865.701 403.417C865.763 404.021 865.89 404.616 866.079 405.193C865.828 406.002 866.281 406.86 867.09 407.111C867.899 407.361 868.759 406.909 869.009 406.1C869.494 405.734 869.938 405.316 870.332 404.853V405.533C870.332 405.533 870.332 405.647 870.332 405.703C870.332 405.703 870.332 405.798 870.332 405.854C870.332 405.854 870.332 405.854 870.332 405.987C870.332 405.987 870.332 406.1 870.332 406.138C870.332 406.302 870.332 406.465 870.332 406.629C870.309 406.878 870.264 407.124 870.2 407.366V407.46V407.574V407.687C869.141 408.235 867.95 408.008 866.797 409.312",
  fill: "#9452BA"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M876.533 417.077L877.1 416.17L879.595 417.738L880.559 416.189L881.467 416.756L879.936 419.212L879.917 419.193V419.212L876.533 417.077Z",
  fill: "#9ACDED"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M875.039 418.475L859.122 422.083L875.039 418.475Z",
  fill: "white"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M875.039 418.475L859.122 422.083",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M877.629 421.97L878.215 421.044L880.711 422.631L881.675 421.082L882.582 421.649L881.051 424.105L881.032 424.086V424.105L877.629 421.97Z",
  fill: "#9ACDED"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M876.193 423.595L860.294 427.203L876.193 423.595Z",
  fill: "white"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M876.193 423.595L860.294 427.203",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M878.745 426.863L879.312 425.938L881.807 427.506L882.79 425.975L883.697 426.542L882.147 428.979L882.128 428.998L878.745 426.863Z",
  fill: "#9ACDED"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  d: "M877.402 428.904L861.504 432.493L877.402 428.904Z",
  fill: "white"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M877.402 428.904L861.504 432.493",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  d: "M897.655 431.899C897.93 433.111 897.17 434.317 895.958 434.591L866.407 441.291C865.195 441.565 863.99 440.806 863.715 439.594L853.55 394.807C853.275 393.595 854.035 392.389 855.247 392.115L884.798 385.415C886.01 385.141 887.215 385.9 887.49 387.112L897.655 431.899Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  d: "M892.544 426.353L867.308 434.061L858.555 395.444L884.227 388.303L892.544 426.353Z",
  fill: "#E1F2FF"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  d: "M884.51 410.672L867.705 414.488L884.51 410.672Z",
  fill: "white"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  d: "M884.51 410.672L867.705 414.488",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  d: "M885.739 416.094L868.934 419.911L885.739 416.094Z",
  fill: "white"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  d: "M885.739 416.094L868.934 419.911",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  d: "M887.025 421.706L870.2 425.503L887.025 421.706Z",
  fill: "white"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  d: "M887.025 421.706L870.2 425.503",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  d: "M110.85 372.093C102.819 374.651 95.5671 379.201 89.7719 385.318C76.8794 399.223 66.1987 443.527 115.821 443.735C156.956 443.905 157.958 442.45 161.815 429.244C164.442 420.27 163.705 389.89 144.99 377.761C133.081 370.43 123.912 372.093 123.912 372.093C123.912 372.093 131.701 360.417 125.803 354.693C119.394 354.693 117.787 363.402 117.787 363.402C117.787 363.402 114.801 354.466 111.833 354.693C108.865 354.919 106.048 358.49 110.85 372.093Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  d: "M162.646 422.612C164.537 413.449 163.799 389.871 145.009 377.723C133.1 370.393 123.931 372.055 123.931 372.055C123.931 372.055 131.72 360.379 125.822 354.655C124.914 363.591 117.674 374.681 117.674 374.681C117.674 374.681 159.036 396.559 144.839 438.463C156.219 437.727 162.155 424.993 162.646 422.612Z",
  fill: "#9ACDED"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  d: "M95.3107 394.519C91.1851 400.187 89.5034 407.27 90.6414 414.186",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  d: "M103.213 428.564C103.213 428.564 104.366 432.229 107.371 432.456",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  d: "M122.913 394.998C123.185 393.785 124.389 393.023 125.601 393.295L153.464 399.547C154.676 399.819 155.439 401.022 155.166 402.235L145.656 444.576C145.383 445.788 144.18 446.551 142.968 446.279L115.105 440.027C113.892 439.755 113.13 438.552 113.402 437.339L122.913 394.998Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2.00878
})), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
  d: "M115.576 432.701L142.816 440.882L151.72 401.622L124.026 393.99L115.576 432.701Z",
  fill: "#E1F2FF"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.32929,
  ry: 6.33262,
  transform: "matrix(0.221232 -0.975221 0.975232 0.221185 134.2 409.098)",
  fill: "white"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.32929,
  ry: 6.33262,
  transform: "matrix(0.221232 -0.975221 0.975232 0.221185 135.232 407.998)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
  d: "M136.011 411.371C136.011 411.371 136.011 411.503 136.011 411.522C136.219 409.803 137.334 409.312 137.901 408.273C138.031 407.912 138.031 407.518 137.901 407.158V407.045V406.837V406.723C137.593 406.169 137.226 405.649 136.805 405.174C136.743 405.778 136.616 406.373 136.427 406.95C136.182 407.631 135.831 408.268 135.387 408.839C134.714 408.636 134.076 408.33 133.497 407.933C133.011 407.566 132.568 407.148 132.173 406.686V407.366C132.173 407.366 132.173 407.479 132.173 407.536C132.173 407.536 132.173 407.63 132.173 407.687C132.173 407.687 132.173 407.687 132.173 407.819C132.173 407.819 132.173 407.933 132.173 407.97C132.173 408.134 132.173 408.298 132.173 408.462C132.197 408.71 132.241 408.957 132.306 409.198V409.293V409.406V409.52C133.364 410.067 134.555 409.841 135.708 411.144",
  fill: "#9452BA"
})), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
  d: "M126.048 418.815L125.462 417.908L122.986 419.476L122.003 417.927L121.096 418.513L122.646 420.95L126.048 418.815Z",
  fill: "#9ACDED"
})), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
  d: "M127.542 420.232L143.44 423.822L127.542 420.232Z",
  fill: "white"
})), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
  d: "M127.542 420.232L143.44 423.822",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
  d: "M124.933 423.708L124.366 422.801L121.871 424.369L120.888 422.82L119.98 423.406L121.53 425.843H121.549L124.933 423.708Z",
  fill: "#9ACDED"
})), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
  d: "M126.37 425.352L142.287 428.96L126.37 425.352Z",
  fill: "white"
})), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
  d: "M126.37 425.352L142.287 428.96",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
  d: "M123.818 428.601L123.251 427.695L120.755 429.263L119.791 427.713L118.884 428.299L120.415 430.736H120.434L123.818 428.601Z",
  fill: "#9ACDED"
})), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
  d: "M125.179 430.642L141.077 434.25L125.179 430.642Z",
  fill: "white"
})), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
  d: "M125.179 430.642L141.077 434.25",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
  d: "M115.013 388.814C115.288 387.602 116.493 386.843 117.705 387.118L147.256 393.817C148.468 394.091 149.228 395.297 148.953 396.509L138.788 441.296C138.513 442.508 137.308 443.267 136.096 442.993L106.545 436.294C105.333 436.019 104.573 434.813 104.848 433.601L115.013 388.814Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
  d: "M110.037 428.11L135.255 435.8L144.026 397.201L118.355 390.041L110.037 428.11Z",
  fill: "#E1F2FF"
})), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
  d: "M118.052 412.429L134.877 416.245L118.052 412.429Z",
  fill: "white"
})), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
  d: "M118.052 412.429L134.877 416.245",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
  d: "M116.823 417.851L133.648 421.649L116.823 417.851Z",
  fill: "white"
})), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
  d: "M116.823 417.851L133.648 421.649",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
  d: "M115.557 423.444L132.381 427.26L115.557 423.444Z",
  fill: "white"
})), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
  d: "M115.557 423.444L132.381 427.26",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 772.07,
  y: 342.771,
  width: 93.5932,
  height: 100.756,
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 725.188,
  y: 342.866,
  width: 46.7871,
  height: 100.756,
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
  d: "M736.625 401.962H758.27",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
  d: "M736.625 409.727H758.27",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
  d: "M736.625 417.511H758.27",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
  d: "M339.795 443.621H921.259H339.795Z",
  fill: "white"
})), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
  d: "M339.795 443.621H921.259",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
  d: "M932.394 309.784V320.062",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
  d: "M937.536 314.923H927.252",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
  d: "M576.963 305.439H512.784L477.623 263.383H541.783L576.963 305.439Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
  d: "M576.963 305.439H705.301L740.463 263.383H612.124L576.963 305.439Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
  d: "M532.369 355.637V361.418",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
  d: "M535.261 358.528H529.476",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
  d: "M511.457 227.85C511.094 226.662 511.764 225.404 512.953 225.042L598.533 198.958C599.721 198.596 600.978 199.265 601.341 200.454L639.78 326.425C640.143 327.613 639.473 328.871 638.284 329.233L552.705 355.317C551.516 355.679 550.259 355.01 549.896 353.822L511.457 227.85Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
  d: "M553.068 338.879L632.219 320.667L598.646 210.653L519.155 230.944L553.068 338.879Z",
  fill: "#E1F2FF"
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.0712,
  ry: 18.0625,
  transform: "matrix(0.956518 -0.291674 0.291734 0.9565 565.745 253.852)",
  fill: "white"
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.0712,
  ry: 18.0625,
  transform: "matrix(0.956518 -0.291674 0.291734 0.9565 566.762 249.711)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
  d: "M573.655 256.979L573.938 257.338C572.048 252.785 574.09 250.007 573.938 246.607C573.934 246.55 573.934 246.493 573.938 246.437C573.942 246.361 573.942 246.285 573.938 246.21C573.668 245.145 573.033 244.209 572.142 243.565L571.897 243.357L571.405 242.979L571.254 242.885L571.103 242.79L570.951 242.696L570.8 242.601H570.687C569.137 241.662 567.489 240.895 565.772 240.315C566.464 241.905 566.984 243.564 567.322 245.265C567.632 247.256 567.632 249.282 567.322 251.273C565.358 251.719 563.336 251.859 561.329 251.689C559.608 251.47 557.915 251.065 556.282 250.48L556.471 250.895V251.027L556.603 251.33V251.462L556.755 251.764V251.878L556.944 252.256L557.171 252.69L557.378 253.068L557.568 253.408L557.794 253.786C558.046 254.189 558.305 254.573 558.569 254.938C558.984 255.517 559.446 256.06 559.949 256.563L560.157 256.752L560.346 256.922L560.554 257.092L560.819 257.281L561.121 257.47L561.329 257.583H561.462H561.556H561.67H561.764H561.897H561.991H562.123H563.239C566.641 257.451 569.288 255.203 573.976 256.79",
  fill: "#9ACDED"
})), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
  d: "M559.344 289.663L556.641 288.228L552.69 295.633L548.078 293.177L546.641 295.879L553.919 299.771L553.938 299.752H553.957L559.344 289.663Z",
  fill: "#9ACDED"
})), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
  d: "M565.035 291.024L609.591 277.44L565.035 291.024Z",
  fill: "white"
})), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
  d: "M565.035 291.024L609.591 277.44",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
  d: "M563.522 303.361L560.819 301.925L556.868 309.331L552.256 306.875L550.819 309.576L558.116 313.468V313.449H558.135L563.522 303.361Z",
  fill: "#9ACDED"
})), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
  d: "M569.42 305.382L613.977 291.798L569.42 305.382Z",
  fill: "white"
})), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
  d: "M569.42 305.382L613.977 291.798",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
  d: "M567.7 317.058L564.997 315.622L561.046 323.028L556.433 320.591L554.997 323.293L562.293 327.166V327.147L562.312 327.166L567.7 317.058Z",
  fill: "#9ACDED"
})), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
  d: "M573.938 320.213L618.495 306.648L573.938 320.213Z",
  fill: "white"
})), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
  d: "M573.938 320.213L618.495 306.648",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
  d: "M680.915 303.417V309.199V303.417Z",
  fill: "white"
})), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
  d: "M680.915 303.417V309.199",
  stroke: "#375D81",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
  d: "M683.808 306.308H678.042H683.808Z",
  fill: "white"
})), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
  d: "M683.808 306.308H678.042",
  stroke: "#375D81",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
  d: "M630.647 222.1C631.063 220.929 632.349 220.317 633.52 220.732L719.335 251.17C720.506 251.586 721.119 252.872 720.703 254.043L675.863 380.312C675.448 381.483 674.162 382.095 672.991 381.679L587.176 351.241C586.005 350.826 585.392 349.539 585.808 348.368L630.647 222.1Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
  d: "M597.511 337.991L673.222 370.922L712.353 260.72L635.092 229.263L597.511 337.991Z",
  fill: "#E1F2FF"
})), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.3651,
  ry: 18.3734,
  transform: "matrix(0.334498 -0.942397 0.94242 0.334432 659.303 276.178)",
  fill: "white"
})), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.3651,
  ry: 18.3734,
  transform: "matrix(0.334498 -0.942397 0.94242 0.334432 662.635 273.425)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
  d: "M663.902 283.485C663.902 283.731 663.902 283.901 663.902 283.958C665.093 279.064 668.458 278.044 670.443 275.229V275.078L670.556 274.87C670.98 273.836 671.027 272.686 670.688 271.621V271.3L670.499 270.695V270.525V270.355V270.185V270.015V269.883C669.797 268.178 668.91 266.556 667.853 265.046C667.46 266.765 666.883 268.438 666.133 270.034C665.183 271.848 663.959 273.505 662.503 274.946C660.63 274.121 658.896 273.012 657.361 271.658C656.083 270.439 654.942 269.083 653.958 267.615L653.845 268.069V268.201V268.522V268.673V269.013V269.146V269.561V270.053V270.487V270.884C653.845 271.035 653.845 271.186 653.845 271.337C653.845 271.816 653.845 272.288 653.845 272.754C653.83 273.475 653.875 274.195 653.977 274.908V275.191V275.437V275.702L654.072 276.023L654.204 276.363L654.299 276.59V276.722V276.835V276.948V277.043L654.412 277.137L654.582 277.27H654.677C657.531 279.159 661.066 278.989 663.94 283.108",
  fill: "#9452BA"
})), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
  d: "M632.408 301.547L631.066 298.732L623.353 302.397L621.085 297.617L618.268 298.959L621.879 306.535L621.897 306.516L621.916 306.554L632.408 301.547Z",
  fill: "#9ACDED"
})), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
  d: "M636.246 306.1L680.878 321.932L636.246 306.1Z",
  fill: "white"
})), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
  d: "M636.246 306.1L680.878 321.932",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
  d: "M627.55 315.282L626.208 312.467L618.495 316.132L616.207 311.333L613.391 312.675L617.001 320.27L617.02 320.251L617.039 320.27L627.55 315.282Z",
  fill: "#9ACDED"
})), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
  d: "M631.141 320.478L675.774 336.31L631.141 320.478Z",
  fill: "white"
})), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
  d: "M631.141 320.478L675.774 336.31",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
  d: "M622.673 328.998L621.33 326.183L613.618 329.867L611.33 325.069L608.513 326.41L612.124 333.986L612.143 333.967L612.162 334.005L622.673 328.998Z",
  fill: "#9ACDED"
})), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
  d: "M625.848 335.346L670.499 351.178L625.848 335.346Z",
  fill: "white"
})), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
  d: "M625.848 335.346L670.499 351.178",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
  d: "M609.506 195.527C609.85 194.333 611.097 193.644 612.291 193.987L699.505 219.08C700.7 219.423 701.389 220.67 701.045 221.865L664.078 350.203C663.734 351.397 662.487 352.086 661.293 351.742L574.079 326.65C572.884 326.306 572.195 325.059 572.539 323.865L609.506 195.527Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
  d: "M661.539 335.327L581.046 318.116L613.315 206.081L694.186 225.39L661.539 335.327Z",
  fill: "#E1F2FF"
})), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
  d: "M622.154 236.944C623.308 232.874 627.543 230.511 631.612 231.664L659.43 239.547C663.501 240.7 665.865 244.936 664.71 249.007L660.811 262.751C659.657 266.82 655.423 269.183 651.353 268.03L623.535 260.147C619.464 258.994 617.1 254.758 618.255 250.688L622.154 236.944Z",
  fill: "white"
})), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
  d: "M626.002 234.206C627.156 230.137 631.39 227.774 635.46 228.927L663.278 236.809C667.349 237.963 669.713 242.199 668.558 246.269L664.659 260.013C663.505 264.083 659.27 266.446 655.201 265.293L627.383 257.41C623.312 256.256 620.948 252.021 622.103 247.95L626.002 234.206Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M639.799 241.09C639.321 240.785 638.798 240.555 638.249 240.41L635.244 239.522L632.578 248.779L634.298 249.27L635.244 246.021L636.529 246.399C637.062 246.562 637.617 246.638 638.174 246.625C638.625 246.616 639.069 246.513 639.478 246.323C639.849 246.142 640.172 245.876 640.423 245.549C640.692 245.199 640.891 244.802 641.009 244.377C641.132 243.974 641.177 243.551 641.142 243.13C641.1 242.732 640.964 242.35 640.745 242.016C640.497 241.645 640.175 241.33 639.799 241.09ZM637.777 245.171C637.483 245.181 637.189 245.142 636.907 245.057L635.565 244.679L636.529 241.354L637.815 241.732C638.096 241.811 638.364 241.932 638.609 242.091C638.806 242.217 638.974 242.385 639.1 242.582C639.208 242.767 639.273 242.974 639.289 243.187C639.333 243.418 639.333 243.655 639.289 243.886C639.223 244.13 639.114 244.36 638.968 244.566C638.834 244.749 638.659 244.898 638.457 245.001C638.246 245.106 638.013 245.164 637.777 245.171Z",
  fill: "#9ACDED"
})), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M649.176 250.593C649.576 250.062 649.871 249.459 650.045 248.817C650.259 248.185 650.348 247.518 650.31 246.852C650.255 246.243 650.075 245.651 649.781 245.114C649.477 244.576 649.065 244.107 648.571 243.735C648.005 243.318 647.363 243.017 646.68 242.847L643.145 241.827L640.48 251.084L644.015 252.104C644.67 252.3 645.356 252.37 646.038 252.312C647.281 252.211 648.422 251.586 649.176 250.593ZM648.476 246.89C648.49 247.369 648.426 247.848 648.287 248.307H648.306C648.174 248.786 647.963 249.239 647.682 249.648C647.455 249.989 647.159 250.279 646.813 250.498C646.474 250.707 646.093 250.836 645.697 250.876C645.264 250.918 644.827 250.873 644.412 250.744L642.522 250.234L644.412 243.716L646.302 244.226C646.72 244.337 647.112 244.53 647.456 244.793C647.766 245.036 648.018 245.346 648.193 245.7C648.37 246.072 648.466 246.478 648.476 246.89Z",
  fill: "#9ACDED"
})), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
  d: "M654.242 246.493L653.448 249.233L656.926 250.234L656.529 251.613L653.051 250.612L651.974 254.39L650.253 253.899L652.919 244.642L658.76 246.323L658.363 247.683L654.242 246.493Z",
  fill: "#9ACDED"
})), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
  d: "M612.313 276.552L657.701 289.607L612.313 276.552Z",
  fill: "white"
})), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
  d: "M612.313 276.552L657.701 289.607",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
  d: "M608.117 291.175L653.486 304.23L608.117 291.175Z",
  fill: "white"
})), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
  d: "M608.117 291.175L653.486 304.23",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
  d: "M603.75 306.289L649.138 319.344L603.75 306.289Z",
  fill: "white"
})), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
  d: "M603.75 306.289L649.138 319.344",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
  d: "M582.086 277.973C582.665 276.874 584.026 276.453 585.125 277.032L675.673 324.745C676.773 325.325 677.194 326.686 676.614 327.785L618.153 438.602C617.574 439.701 616.213 440.122 615.114 439.543L524.566 391.83C523.466 391.25 523.045 389.889 523.625 388.79L582.086 277.973Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
  d: "M617.606 423.935L533.597 385.733L584.732 288.794L668.855 329.074L617.606 423.935Z",
  fill: "#E1F2FF"
})), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 17.2137,
  ry: 20.5459,
  transform: "matrix(0.466428 -0.884559 0.884603 0.466346 608.704 335.668)",
  fill: "white"
})), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 17.2136,
  ry: 20.5459,
  transform: "matrix(0.466427 -0.884559 0.884602 0.466346 612.539 333.764)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
  d: "M613.069 343.602C613.069 343.829 613.069 343.999 613.069 344.056C614.752 339.635 618.457 339.389 620.82 337.103L620.914 336.99L621.066 336.82C621.618 335.893 621.768 334.781 621.482 333.74V333.419C621.482 333.211 621.482 333.004 621.33 332.796V332.626V332.456V332.286V332.097V331.964C620.698 330.15 619.874 328.409 618.873 326.769C618.314 328.326 617.558 329.806 616.623 331.171C615.432 332.727 613.972 334.057 612.313 335.101C610.37 333.922 608.59 332.493 607.02 330.85C605.756 329.434 604.635 327.896 603.674 326.259L603.523 326.674V326.807L603.428 327.109V327.241L603.334 327.544V327.676L603.22 328.054L603.107 328.507L603.012 328.904V329.282V329.697C602.937 330.151 602.874 330.598 602.823 331.039C602.759 331.736 602.759 332.438 602.823 333.136V333.419V333.665V333.929V334.25L602.937 334.609V334.836V334.931V335.063V335.157V335.29V335.403V335.516L603.05 335.63L603.22 335.8L603.334 335.894C606.264 338.369 610.083 338.898 612.786 343.451",
  fill: "#9ACDED"
})), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
  d: "M577.643 354.145L576.434 351.16L567.813 353.011L565.734 347.948L562.596 348.628L565.866 356.639H565.904V356.657L577.643 354.145Z",
  fill: "#9ACDED"
})), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
  d: "M581.689 359.737L628.552 384.43L581.689 359.737Z",
  fill: "white"
})), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
  d: "M581.689 359.737L628.552 384.43",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
  d: "M571.273 366.217L570.063 363.232L561.443 365.084L559.363 360.02L556.225 360.7L559.496 368.711H559.534L559.552 368.73L571.273 366.217Z",
  fill: "#9ACDED"
})), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
  d: "M574.732 371.961L621.595 396.654L574.732 371.961Z",
  fill: "white"
})), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
  d: "M574.732 371.961L621.595 396.654",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
  d: "M564.902 378.29L563.692 375.305L555.072 377.156L552.993 372.093L549.855 372.773L553.144 380.784H553.163L553.182 380.821L564.902 378.29Z",
  fill: "#9ACDED"
})), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
  d: "M567.832 385.034L614.695 409.727L567.832 385.034Z",
  fill: "white"
})), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
  d: "M567.832 385.034L614.695 409.727",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
  d: "M508.848 277.742C508.464 276.56 509.11 275.29 510.292 274.906L586.058 250.259C587.239 249.874 588.509 250.52 588.893 251.702L608.493 311.882C608.878 313.063 608.232 314.333 607.05 314.718L531.284 339.365C530.103 339.75 528.833 339.104 528.448 337.922L508.848 277.742Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
  d: "M519.059 284.693C518.674 283.512 519.321 282.242 520.503 281.857L581.924 261.876C583.106 261.492 584.375 262.138 584.76 263.319L597.689 303.019C598.074 304.201 597.428 305.471 596.246 305.855L534.825 325.836C533.643 326.22 532.374 325.574 531.989 324.393L519.059 284.693Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
  d: "M520.516 289.229L519.155 285.072C518.707 283.706 519.452 282.235 520.818 281.785L581.557 262.023C582.924 261.576 584.396 262.32 584.846 263.686L586.169 267.748L520.516 289.229Z",
  fill: "#9ACDED",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
  d: "M596.264 298.732L597.568 302.718C598.016 304.085 597.271 305.556 595.905 306.006L535.166 325.768C533.799 326.215 532.327 325.471 531.877 324.105L530.497 319.835L596.264 298.732Z",
  fill: "#9ACDED",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
  d: "M565.488 288.511L553.9 285.998C553.047 285.813 552.16 286.098 551.574 286.746C550.989 287.394 550.794 288.304 551.065 289.134L554.694 300.47C554.959 301.303 555.651 301.931 556.506 302.114C557.362 302.298 558.25 302.009 558.834 301.358L566.793 292.573C567.401 291.927 567.61 291.002 567.339 290.157C567.068 289.313 566.359 288.682 565.488 288.511Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
  d: "M613.989 259.442C614.146 258.21 615.272 257.337 616.505 257.494L695.171 267.496C696.404 267.653 697.277 268.779 697.12 270.012L688.501 337.723C688.344 338.955 687.217 339.827 685.985 339.671L607.318 329.669C606.085 329.512 605.213 328.386 605.37 327.153L613.989 259.442Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
  d: "M620.218 270.025C620.375 268.792 621.501 267.92 622.734 268.077L686.492 276.183C687.725 276.34 688.597 277.466 688.44 278.699L683.195 319.909C683.038 321.141 681.911 322.014 680.679 321.857L616.92 313.75C615.687 313.594 614.815 312.467 614.972 311.234L620.218 270.025Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
  d: "M615.64 305.76C615.64 305.344 624.884 299.431 629.856 296.314C631.667 295.116 634.083 295.43 635.527 297.05L643.637 305.855C644.072 306.332 644.797 306.405 645.319 306.025L661.879 294.16C663.539 292.963 665.806 293.073 667.342 294.424L684.621 309.539L683.543 317.965C683.425 318.912 682.934 319.772 682.177 320.354C681.421 320.936 680.463 321.192 679.517 321.063L617.361 312.902C616.587 312.802 615.89 312.385 615.438 311.75C614.986 311.115 614.819 310.32 614.979 309.558L615.64 305.76Z",
  fill: "#9ACDED"
})), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 4.70437,
  ry: 4.70701,
  transform: "matrix(0.130367 -0.991466 0.991469 0.130339 675.099 285.239)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 641.028,
  y: 443.489,
  width: 128.357,
  height: 138.201,
  transform: "rotate(-180 641.028 443.489)",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
  d: "M514.183 370.109L641.123 370.487L641.009 305.288H514.183V370.109Z",
  fill: "#E1F2FF"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 705.301,
  y: 443.621,
  width: 64.1787,
  height: 138.201,
  transform: "rotate(-180 705.301 443.621)",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
  d: "M703.865 354.655L642.522 370.487L642.635 305.288H705.301L703.865 354.655Z",
  fill: "#E1F2FF"
})), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
  d: "M641.123 305.439H705.301L740.463 347.494H676.303L641.123 305.439Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
  d: "M641.123 305.439H512.784L477.623 347.494H605.961L641.123 305.439Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
  d: "M689.63 386.489H659.932",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
  d: "M689.63 397.145H659.932",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
  d: "M689.63 407.8H659.932",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
  d: "M496.565 339.862H526.508",
  stroke: "#E1F2FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
  d: "M705.528 339.862H725.188",
  stroke: "#E1F2FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
  d: "M520.799 437.557V416.642",
  stroke: "#E1F2FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
  d: "M513.578 307.177L568.324 307.215L519.155 345.7H481.12L513.578 307.177Z",
  fill: "#E1F2FF"
})), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
  d: "M448.77 376.827C448.763 375.585 449.766 374.572 451.008 374.566L528.626 374.173C529.868 374.167 530.881 375.169 530.887 376.412L531.199 438.036C531.205 439.279 530.203 440.291 528.96 440.298L451.343 440.69C450.1 440.696 449.088 439.694 449.082 438.452L448.77 376.827Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
  d: "M456.171 386.312C456.165 385.069 457.167 384.057 458.41 384.051L521.301 383.733C522.544 383.726 523.556 384.729 523.563 385.971L523.768 426.587C523.775 427.829 522.772 428.842 521.53 428.848L458.638 429.166C457.396 429.173 456.383 428.17 456.377 426.928L456.171 386.312Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
  d: "M456.205 390.872V386.603C456.205 385.201 457.336 384.062 458.738 384.052L521.121 383.731C522.471 383.801 523.532 384.911 523.54 386.263V390.438L456.205 390.872Z",
  fill: "#9ACDED",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
  d: "M523.767 422.197V426.296C523.767 427.698 522.636 428.837 521.234 428.847L458.851 429.168C457.449 429.168 456.31 428.038 456.299 426.637V422.272L523.767 422.197Z",
  fill: "#9ACDED",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
  d: "M498.134 403.512L488.285 397.844C487.529 397.403 486.595 397.401 485.837 397.838C485.079 398.276 484.613 399.085 484.617 399.96V411.296C484.613 412.17 485.079 412.98 485.837 413.417C486.595 413.854 487.529 413.852 488.285 413.412L498.115 407.744C498.876 407.313 499.349 406.508 499.353 405.633C499.357 404.759 498.891 403.949 498.134 403.512Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
  d: "M622.049 383.844V389.625",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
  d: "M624.941 386.735H619.156",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
  d: "M519.022 295.69V274.776",
  stroke: "#E1F2FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
  d: "M313.386 435.781V414.866",
  stroke: "#E1F2FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
  d: "M63.5144 102.813V113.072",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
  d: "M68.6562 107.933H58.3725",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
  d: "M631.141 120.289V130.548",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
  d: "M636.283 125.428H626",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
  d: "M824.566 248.194V253.975",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
  d: "M827.458 251.084H821.674",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
  d: "M366.166 1.79297V12.0707",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
  d: "M371.307 6.93183H361.024",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 221.759,
  y: 204.362,
  width: 93.5932,
  height: 100.756,
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 174.877,
  y: 204.457,
  width: 46.7871,
  height: 100.756,
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
  d: "M186.314 263.553H207.959",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
  d: "M186.314 271.337H207.959",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
  d: "M186.314 279.102H207.959",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
  d: "M254.746 151.727V157.508",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
  d: "M257.62 154.617H251.854",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 433.142,
  y: 443.489,
  width: 128.357,
  height: 138.201,
  transform: "rotate(-180 433.142 443.489)",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 497.434,
  y: 443.621,
  width: 64.1787,
  height: 138.201,
  transform: "rotate(-180 497.434 443.621)",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
  d: "M481.744 386.489H452.065",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
  d: "M481.744 397.145H452.065",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
  d: "M481.744 407.8H452.065",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 370.079,
  cy: 373.415,
  rx: 25.8794,
  ry: 25.8643,
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
  d: "M431.327 343.206L306.202 328.28L306.316 306.761H431.327V343.206Z",
  fill: "#E1F2FF"
})), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
  d: "M435.089 343.206L495.619 342.96L495.563 306.761H435.089V343.206Z",
  fill: "#E1F2FF"
})), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
  d: "M227.014 305.439H291.193L326.354 263.383H262.194L227.014 305.439Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
  d: "M227.014 305.439H98.6756L63.5144 263.383H191.853L227.014 305.439Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
  d: "M118.26 355.637V361.418",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
  d: "M121.152 358.528H115.368",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
  d: "M166.384 227.87C166.021 226.682 166.691 225.424 167.88 225.062L253.46 198.978C254.648 198.616 255.905 199.285 256.268 200.474L294.708 326.445C295.07 327.633 294.4 328.891 293.212 329.253L207.632 355.337C206.443 355.699 205.186 355.03 204.824 353.841L166.384 227.87Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
  d: "M207.978 338.879L287.128 320.667L253.555 210.653L174.064 230.944L207.978 338.879Z",
  fill: "#E1F2FF"
})), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.0712,
  ry: 18.0625,
  transform: "matrix(0.956518 -0.291674 0.291734 0.9565 220.653 253.872)",
  fill: "white"
})), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.0712,
  ry: 18.0625,
  transform: "matrix(0.956518 -0.291674 0.291734 0.9565 221.689 249.731)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
  d: "M228.64 256.979L228.923 257.338C227.033 252.785 229.075 250.007 228.923 246.607C228.919 246.55 228.919 246.493 228.923 246.437C228.927 246.361 228.927 246.285 228.923 246.21C228.654 245.145 228.018 244.209 227.128 243.565L226.882 243.357L226.39 242.979L226.239 242.885L226.088 242.79L225.937 242.696L225.785 242.601H225.672C224.122 241.662 222.474 240.895 220.757 240.315C221.449 241.905 221.969 243.564 222.307 245.265C222.617 247.256 222.617 249.282 222.307 251.273C220.343 251.719 218.322 251.859 216.315 251.689C214.593 251.47 212.901 251.065 211.267 250.48L211.456 250.895V251.027L211.589 251.33V251.462L211.74 251.764V251.878L211.929 252.256L212.156 252.69L212.364 253.068L212.553 253.408L212.779 253.786C213.032 254.189 213.29 254.573 213.555 254.938C213.969 255.517 214.431 256.06 214.935 256.563L215.142 256.752L215.332 256.922L215.539 257.092L215.804 257.281L216.107 257.47L216.315 257.583H216.447H216.541H216.655H216.749H216.882H217.298H217.43H218.073C221.475 257.451 224.122 255.203 228.81 256.79",
  fill: "#9ACDED"
})), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
  d: "M214.254 289.663L211.551 288.228L207.6 295.633L202.987 293.177L201.551 295.879L208.829 299.771L208.847 299.752H208.866L214.254 289.663Z",
  fill: "#9ACDED"
})), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
  d: "M219.944 291.024L264.501 277.44L219.944 291.024Z",
  fill: "white"
})), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
  d: "M219.944 291.024L264.501 277.44",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
  d: "M218.432 303.361L215.728 301.925L211.778 309.331L207.165 306.875L205.728 309.576L213.006 313.468L213.025 313.449H213.044L218.432 303.361Z",
  fill: "#9ACDED"
})), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
  d: "M224.33 305.382L268.886 291.798L224.33 305.382Z",
  fill: "white"
})), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
  d: "M224.33 305.382L268.886 291.798",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
  d: "M222.61 317.058L219.906 315.622L215.955 323.028L211.343 320.591L209.906 323.293L217.203 327.166V327.147L217.241 327.166L222.61 317.058Z",
  fill: "#9ACDED"
})), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
  d: "M228.848 320.213L273.404 306.648L228.848 320.213Z",
  fill: "white"
})), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
  d: "M228.848 320.213L273.404 306.648",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
  d: "M266.826 303.417V309.199V303.417Z",
  fill: "white"
})), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
  d: "M266.826 303.417V309.199",
  stroke: "#375D81",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
  d: "M269.699 306.308H263.933H269.699Z",
  fill: "white"
})), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
  d: "M269.699 306.308H263.933",
  stroke: "#375D81",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
  d: "M218.012 203.008C218.428 201.837 219.714 201.225 220.885 201.64L306.699 232.078C307.871 232.494 308.483 233.78 308.067 234.951L263.228 361.22C262.812 362.391 261.526 363.003 260.355 362.588L174.54 332.149C173.369 331.734 172.757 330.447 173.172 329.276L218.012 203.008Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
  d: "M184.858 318.909L260.587 351.84L299.718 241.638L222.458 210.181L184.858 318.909Z",
  fill: "#E1F2FF"
})), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.3651,
  ry: 18.3734,
  transform: "matrix(0.334498 -0.942396 0.94242 0.334432 246.652 257.096)",
  fill: "white"
})), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.365,
  ry: 18.3734,
  transform: "matrix(0.334498 -0.942396 0.94242 0.334432 249.991 254.345)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
  d: "M251.325 264.404C251.325 264.649 251.325 264.819 251.325 264.876C252.515 259.983 255.88 258.962 257.865 256.147V255.996L257.979 255.788C258.403 254.754 258.45 253.604 258.111 252.539V252.218L257.922 251.613V251.443V251.273V251.103V250.933V250.801C257.22 249.097 256.332 247.475 255.275 245.964C254.883 247.684 254.306 249.356 253.555 250.952C252.605 252.766 251.381 254.423 249.926 255.864C248.053 255.039 246.318 253.93 244.784 252.577C243.506 251.357 242.365 250.001 241.381 248.534L241.268 248.987V249.119V249.44V249.592V249.932V250.064V250.48V250.971V251.405V251.802C241.268 251.953 241.268 252.104 241.268 252.256C241.268 252.734 241.268 253.206 241.268 253.672C241.253 254.393 241.297 255.113 241.4 255.826V256.11V256.355V256.62L241.494 256.941L241.627 257.281L241.721 257.508V257.64V257.753V257.867V257.961L241.835 258.056L242.005 258.188H242.099C244.954 260.077 248.489 259.907 251.362 264.026",
  fill: "#9ACDED"
})), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
  d: "M219.774 282.465L218.432 279.65L210.719 283.315L208.432 278.535L205.615 279.877L209.226 287.453L209.263 287.434V287.472L219.774 282.465Z",
  fill: "#9ACDED"
})), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
  d: "M223.611 287.018L268.243 302.851L223.611 287.018Z",
  fill: "white"
})), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
  d: "M223.611 287.018L268.243 302.851",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
  d: "M214.897 296.2L213.555 293.385L205.842 297.05L203.554 292.271L200.757 293.593L204.367 301.188L204.386 301.169V301.188L214.897 296.2Z",
  fill: "#9ACDED"
})), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
  d: "M218.488 301.396L263.139 317.247L218.488 301.396Z",
  fill: "white"
})), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
  d: "M218.488 301.396L263.139 317.247",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
  d: "M210.02 309.917L208.677 307.101L200.965 310.786L198.696 305.987L195.879 307.328L199.49 314.904H199.509L199.528 314.923L210.02 309.917Z",
  fill: "#9ACDED"
})), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
  d: "M213.214 316.264L257.865 332.116L213.214 316.264Z",
  fill: "white"
})), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
  d: "M213.214 316.264L257.865 332.116",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
  d: "M80.5877 237.575C80.1724 236.403 80.7857 235.117 81.9573 234.702L167.503 204.41C168.674 203.995 169.96 204.608 170.375 205.779L215.003 331.661C215.418 332.833 214.805 334.119 213.633 334.534L128.088 364.826C126.917 365.241 125.631 364.628 125.216 363.457L80.5877 237.575Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
  d: "M204.254 321.025L128.752 353.823L89.8097 243.943L166.843 212.618L204.254 321.025Z",
  fill: "#E1F2FF"
})), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
  d: "M114.958 263.865C113.528 259.882 115.598 255.495 119.581 254.066L146.796 244.306C150.777 242.879 155.163 244.948 156.592 248.929L161.42 262.375C162.85 266.358 160.78 270.745 156.797 272.173L129.582 281.933C125.601 283.361 121.215 281.292 119.786 277.311L114.958 263.865Z",
  fill: "white"
})), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
  d: "M116.511 259.391C115.081 255.409 117.151 251.022 121.134 249.593L148.349 239.833C152.33 238.405 156.715 240.475 158.145 244.455L162.973 257.902C164.403 261.884 162.332 266.272 158.349 267.7L131.135 277.46C127.153 278.888 122.768 276.819 121.339 272.838L116.511 259.391Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.72 257.035C131.157 257.064 130.603 257.179 130.075 257.375L127.107 258.415L130.321 267.502L132.003 266.897L130.869 263.705L132.135 263.251C132.665 263.074 133.163 262.812 133.61 262.477C133.972 262.208 134.275 261.867 134.498 261.475C134.694 261.115 134.804 260.714 134.82 260.304C134.833 259.866 134.763 259.43 134.612 259.019C134.475 258.618 134.264 258.246 133.988 257.923C133.725 257.623 133.395 257.39 133.024 257.243C132.608 257.084 132.164 257.014 131.72 257.035ZM132.476 261.551C132.241 261.724 131.979 261.858 131.701 261.948L130.453 262.401L129.3 259.151L130.566 258.698C130.84 258.598 131.127 258.541 131.417 258.528C131.65 258.516 131.882 258.555 132.098 258.641C132.295 258.726 132.469 258.856 132.608 259.019C132.76 259.204 132.875 259.415 132.948 259.643C133.035 259.879 133.08 260.128 133.081 260.379C133.081 260.602 133.029 260.822 132.929 261.022C132.818 261.229 132.663 261.409 132.476 261.551Z",
  fill: "#9ACDED"
})), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M144.896 259.227C144.906 258.583 144.797 257.942 144.574 257.338C144.371 256.674 144.036 256.057 143.591 255.524C143.193 255.064 142.704 254.691 142.155 254.428C141.597 254.17 140.992 254.028 140.378 254.013C139.694 253.998 139.014 254.113 138.374 254.353L134.914 255.581L138.128 264.668L141.587 263.44C142.231 263.219 142.827 262.879 143.346 262.439C144.294 261.636 144.858 260.469 144.896 259.227ZM142.155 256.676C142.448 257.059 142.678 257.486 142.835 257.942V257.961C142.999 258.416 143.089 258.895 143.1 259.378C143.116 259.791 143.045 260.203 142.892 260.587C142.738 260.949 142.505 261.271 142.211 261.532C141.885 261.817 141.506 262.036 141.096 262.174L139.338 262.798L137.069 256.412L138.827 255.788C139.232 255.637 139.662 255.566 140.094 255.581C140.49 255.595 140.878 255.699 141.228 255.883C141.589 256.08 141.905 256.35 142.155 256.676Z",
  fill: "#9ACDED"
})), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
  d: "M146.616 253.068L147.561 255.751L150.964 254.542L151.436 255.883L148.034 257.092L149.338 260.871L147.637 261.475L144.423 252.388L150.094 250.366L150.567 251.708L146.616 253.068Z",
  fill: "#9ACDED"
})), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
  d: "M130.018 301.83L174.537 286.074L130.018 301.83Z",
  fill: "white"
})), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
  d: "M130.018 301.83L174.537 286.074",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
  d: "M135.103 316.17L179.622 300.413L135.103 316.17Z",
  fill: "white"
})), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
  d: "M135.103 316.17L179.622 300.413",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
  d: "M140.359 331.001L184.877 315.244L140.359 331.001Z",
  fill: "white"
})), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
  d: "M140.359 331.001L184.877 315.244",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
  d: "M177.051 230.755C171.399 211.711 128.449 166.746 128.449 166.746",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.925 215.093L222.78 267.181C224.271 269.476 224.768 272.277 224.16 274.946L199.585 380.028C199.463 380.552 199.138 381.007 198.68 381.291C198.222 381.574 197.67 381.664 197.146 381.539L101.171 359.151C100.646 359.03 100.191 358.705 99.9075 358.247C99.6236 357.79 99.534 357.238 99.6586 356.714L124.234 251.632C124.851 248.996 126.498 246.717 128.808 245.303L181.38 213.072C184.306 211.321 188.094 212.218 189.925 215.093ZM171.967 239.636C172.501 242.871 174.933 245.466 178.129 246.21C182.487 247.224 186.844 244.519 187.864 240.164C188.612 236.971 187.362 233.643 184.696 231.731C182.03 229.819 178.475 229.701 175.688 231.432C172.901 233.162 171.432 236.401 171.967 239.636Z",
  fill: "white"
})), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
  d: "M222.78 267.181L221.934 267.714L221.941 267.726L222.78 267.181ZM189.925 215.093L190.771 214.56L190.768 214.556L189.925 215.093ZM224.16 274.946L225.133 275.174L225.135 275.168L224.16 274.946ZM199.585 380.028L198.611 379.8L198.61 379.803L199.585 380.028ZM197.146 381.539L197.377 380.566L197.373 380.565L197.146 381.539ZM101.171 359.151L101.398 358.177L101.396 358.177L101.171 359.151ZM99.9075 358.247L99.0578 358.774L99.0578 358.774L99.9075 358.247ZM99.6586 356.714L100.631 356.946L100.632 356.942L99.6586 356.714ZM124.234 251.632L123.26 251.404L123.26 251.404L124.234 251.632ZM128.808 245.303L129.33 246.156L129.331 246.155L128.808 245.303ZM181.38 213.072L180.867 212.214L180.857 212.219L181.38 213.072ZM178.129 246.21L178.355 245.236L178.129 246.21ZM171.967 239.636L170.98 239.799V239.799L171.967 239.636ZM187.864 240.164L186.891 239.936L187.864 240.164ZM184.696 231.731L184.113 232.544V232.544L184.696 231.731ZM175.688 231.432L176.215 232.281L175.688 231.432ZM223.625 266.647L190.77 214.56L189.079 215.627L221.934 267.714L223.625 266.647ZM225.135 275.168C225.804 272.236 225.257 269.159 223.618 266.636L221.941 267.726C223.285 269.794 223.733 272.319 223.185 274.723L225.135 275.168ZM200.558 380.256L225.133 275.174L223.186 274.718L198.611 379.8L200.558 380.256ZM199.207 382.141C199.891 381.717 200.378 381.037 200.559 380.253L198.61 379.803C198.549 380.067 198.385 380.297 198.153 380.441L199.207 382.141ZM196.915 382.512C197.698 382.698 198.523 382.565 199.207 382.141L198.153 380.441C197.922 380.584 197.642 380.629 197.377 380.566L196.915 382.512ZM100.944 360.125L196.919 382.513L197.373 380.565L101.398 358.177L100.944 360.125ZM99.0578 358.774C99.4821 359.458 100.162 359.944 100.946 360.126L101.396 358.177C101.131 358.116 100.901 357.951 100.757 357.72L99.0578 358.774ZM98.6858 356.483C98.4995 357.266 98.6334 358.091 99.0578 358.774L100.757 357.72C100.614 357.489 100.569 357.21 100.631 356.946L98.6858 356.483ZM123.26 251.404L98.6849 356.486L100.632 356.942L125.207 251.86L123.26 251.404ZM128.286 244.45C125.748 246.003 123.938 248.508 123.26 251.404L125.207 251.86C125.763 249.484 127.248 247.43 129.33 246.156L128.286 244.45ZM180.857 212.219L128.286 244.45L129.331 246.155L181.903 213.924L180.857 212.219ZM190.768 214.556C188.647 211.224 184.257 210.185 180.867 212.214L181.894 213.93C184.355 212.457 187.542 213.212 189.081 215.63L190.768 214.556ZM178.355 245.236C175.554 244.584 173.422 242.309 172.953 239.473L170.98 239.799C171.58 243.434 174.313 246.348 177.902 247.184L178.355 245.236ZM186.891 239.936C185.996 243.753 182.177 246.125 178.355 245.236L177.902 247.184C182.797 248.323 187.691 245.284 188.838 240.392L186.891 239.936ZM184.113 232.544C186.45 234.22 187.546 237.137 186.891 239.936L188.838 240.392C189.678 236.805 188.273 233.066 185.279 230.918L184.113 232.544ZM176.215 232.281C178.659 230.764 181.776 230.868 184.113 232.544L185.279 230.918C182.285 228.771 178.291 228.638 175.16 230.582L176.215 232.281ZM172.953 239.473C172.485 236.637 173.772 233.798 176.215 232.281L175.16 230.582C172.03 232.526 170.38 236.164 170.98 239.799L172.953 239.473Z",
  fill: "#9ACDED"
})), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
  d: "M132.514 256.846L112.23 351.311L189.547 370.865L214.33 272.206L193.838 238.785L191.248 247.986C189.919 252.696 185.378 255.756 180.511 255.222C171.04 254.151 162.793 248.273 158.695 239.673L132.514 256.846Z",
  fill: "#E1F2FF"
})), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 25.0338,
  ry: 25.0469,
  transform: "matrix(0.226845 -0.973931 0.973942 0.226797 164.791 293.335)",
  fill: "#EFEFF6"
})), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 25.0338,
  ry: 25.0469,
  transform: "matrix(0.226845 -0.973931 0.973942 0.226797 168.875 289.096)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
  d: "M172.155 302.548C172.155 302.869 172.155 303.096 172.155 303.172C173.025 296.37 177.429 294.481 179.717 290.343V290.136L179.849 289.852C180.271 288.389 180.164 286.824 179.546 285.431L179.395 284.997L179.055 284.203L178.942 283.977L178.828 283.75L178.715 283.523L178.601 283.296V283.126C177.394 280.922 175.949 278.857 174.291 276.967C174.02 279.353 173.494 281.703 172.722 283.977C171.716 286.582 170.313 289.016 168.563 291.194C165.868 290.372 163.317 289.135 161.002 287.528C159.081 286.074 157.325 284.414 155.765 282.579V283.221V283.41C155.765 283.561 155.765 283.712 155.765 283.863V284.071V284.524V284.713C155.765 284.902 155.765 285.091 155.765 285.299C155.765 285.526 155.765 285.753 155.765 285.96C155.765 286.168 155.765 286.357 155.765 286.565V286.678C155.765 286.867 155.765 287.037 155.765 287.226C155.765 287.415 155.765 287.226 155.765 287.34C155.765 287.453 155.765 287.755 155.765 287.963C155.765 288.631 155.809 289.26 155.898 289.852C155.995 290.829 156.172 291.795 156.427 292.743L156.54 293.121L156.654 293.442L156.786 293.782L156.956 294.198L157.183 294.632L157.353 294.916V295.029L157.467 295.199V295.312L157.58 295.463V295.577L157.694 295.709L157.788 295.804L157.92 295.936L158.091 296.049L158.695 296.521L158.847 296.616C163.006 298.826 167.769 297.976 172.287 303.115",
  fill: "#9ACDED"
})), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
  d: "M129.905 328.809L184.858 341.6",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
  d: "M126.521 343.319L181.475 356.11",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
  d: "M134.99 163.214C134.99 163.214 134.99 172.66 137.032 176.438C141.19 183.882 147.088 191.893 151.417 204.268C159.092 226.202 161.909 246.342 175.047 238.634C176.805 237.595 178.582 234.081 177.335 231.908",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.529 180.708C140.529 180.708 135.368 181.313 134.291 179.254C133.213 177.194 144.442 171.999 140.529 180.708Z",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
  d: "M168.003 277.942C168.583 276.843 169.943 276.422 171.042 277.001L261.591 324.714C262.69 325.293 263.112 326.655 262.532 327.754L204.071 438.57C203.491 439.669 202.131 440.09 201.032 439.511L110.483 391.798C109.383 391.219 108.962 389.857 109.542 388.758L168.003 277.942Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
  d: "M203.498 423.935L119.489 385.733L170.624 288.794L254.746 329.074L203.498 423.935Z",
  fill: "#E1F2FF"
})), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 17.2136,
  ry: 20.5459,
  transform: "matrix(0.466427 -0.88456 0.884602 0.466346 194.564 335.661)",
  fill: "white"
})), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 17.2136,
  ry: 20.5459,
  transform: "matrix(0.466427 -0.88456 0.884602 0.466346 198.399 333.757)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
  d: "M198.961 343.602C198.961 343.829 198.961 343.999 198.961 344.056C200.643 339.635 204.348 339.389 206.711 337.103L206.806 336.99L206.957 336.82C207.509 335.893 207.659 334.781 207.373 333.74V333.419C207.373 333.211 207.373 333.004 207.222 332.796V332.626V332.456V332.286V332.097V331.964C206.589 330.15 205.765 328.409 204.764 326.769C204.206 328.326 203.45 329.806 202.515 331.171C201.323 332.727 199.864 334.057 198.205 335.101C196.261 333.922 194.482 332.493 192.911 330.85C191.647 329.434 190.526 327.896 189.566 326.259L189.414 326.674V326.807L189.32 327.109V327.241L189.225 327.544V327.676L189.112 328.054L188.998 328.507L188.904 328.904V329.282V329.697C188.828 330.151 188.765 330.598 188.715 331.039C188.65 331.736 188.65 332.438 188.715 333.136V333.419V333.665V333.929V334.25L188.828 334.609V334.836V334.931V335.063V335.157V335.29V335.403V335.516L188.942 335.63L189.112 335.8L189.225 335.894C192.155 338.369 195.974 338.898 198.677 343.451",
  fill: "#9ACDED"
})), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
  d: "M163.535 354.145L162.325 351.16L153.705 353.011L151.625 347.948L148.487 348.628L151.758 356.639H151.796V356.657L163.535 354.145Z",
  fill: "#9ACDED"
})), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
  d: "M167.58 359.737L214.443 384.43L167.58 359.737Z",
  fill: "white"
})), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
  d: "M167.58 359.737L214.443 384.43",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
  d: "M157.164 366.217L155.954 363.232L147.334 365.084L145.255 360.02L142.117 360.7L145.406 368.711H145.425V368.73L157.164 366.217Z",
  fill: "#9ACDED"
})), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
  d: "M160.624 371.961L207.486 396.654L160.624 371.961Z",
  fill: "white"
})), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
  d: "M160.624 371.961L207.486 396.654",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
  d: "M150.813 378.29L149.584 375.305L140.964 377.156L138.903 372.093L135.746 372.773L139.035 380.784H139.054L139.073 380.821L150.813 378.29Z",
  fill: "#9ACDED"
})), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
  d: "M153.724 385.034L200.587 409.727L153.724 385.034Z",
  fill: "white"
})), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
  d: "M153.724 385.034L200.587 409.727",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
  d: "M213.507 260.189C213.743 258.969 214.924 258.172 216.144 258.408L294.367 273.562C295.587 273.798 296.384 274.979 296.148 276.199L284.097 338.33C283.861 339.55 282.68 340.347 281.46 340.111L203.237 324.957C202.017 324.721 201.22 323.54 201.456 322.32L213.507 260.189Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
  d: "M219.041 271.229C219.278 270.009 220.458 269.212 221.678 269.448L285.091 281.733C286.311 281.969 287.109 283.15 286.872 284.37L278.923 325.357C278.686 326.577 277.506 327.374 276.286 327.137L212.873 314.853C211.653 314.616 210.855 313.436 211.092 312.216L219.041 271.229Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
  d: "M218.167 275.872L218.999 271.564C219.131 270.885 219.529 270.286 220.103 269.9C220.677 269.514 221.382 269.372 222.061 269.505L284.765 281.653C285.445 281.785 286.044 282.182 286.43 282.756C286.817 283.33 286.959 284.034 286.826 284.713L286.013 288.908L218.167 275.872Z",
  fill: "#9ACDED",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
  d: "M279.813 320.855L279.019 324.974C278.886 325.653 278.489 326.252 277.915 326.638C277.34 327.024 276.636 327.167 275.956 327.033L213.252 314.885C212.573 314.753 211.974 314.356 211.587 313.782C211.201 313.208 211.058 312.504 211.192 311.825L212.042 307.423L279.813 320.855Z",
  fill: "#9ACDED",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
  d: "M257.865 297.013L248.943 289.21C248.287 288.632 247.372 288.448 246.544 288.729C245.716 289.01 245.102 289.713 244.935 290.57L242.629 302.189C242.461 303.042 242.761 303.92 243.416 304.493C244.071 305.065 244.981 305.246 245.805 304.967L257.033 301.188C257.875 300.917 258.504 300.211 258.676 299.344C258.849 298.478 258.539 297.586 257.865 297.013Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
  d: "M139.416 272.837C139.303 271.599 140.214 270.504 141.452 270.391L220.424 263.181C221.661 263.068 222.756 263.979 222.869 265.217L229.083 333.19C229.196 334.428 228.284 335.522 227.047 335.635L148.075 342.846C146.837 342.959 145.742 342.048 145.629 340.81L139.416 272.837Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
  d: "M148.125 283.226C148.013 281.988 148.927 280.895 150.164 280.783L214.455 275.001C215.692 274.889 216.786 275.802 216.897 277.04L220.64 318.6C220.751 319.837 219.838 320.931 218.6 321.042L154.31 326.825C153.072 326.937 151.979 326.024 151.868 324.786L148.125 283.226Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2.00808
})), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
  d: "M151.134 317.681C151.134 317.266 158.809 309.501 162.968 305.344C164.477 303.803 166.887 303.594 168.639 304.853L178.299 311.636C178.822 312 179.534 311.919 179.962 311.447L193.554 296.333C194.919 294.813 197.154 294.437 198.942 295.426L219.188 306.554L219.963 315.018C220.052 315.965 219.759 316.91 219.148 317.64C218.538 318.371 217.661 318.828 216.711 318.91L154.329 324.351C153.527 324.465 152.715 324.228 152.103 323.699C151.49 323.17 151.137 322.401 151.134 321.592V317.681Z",
  fill: "#9ACDED"
})), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 4.70705,
  ry: 4.70435,
  transform: "matrix(0.996226 -0.0867985 0.0868176 0.996224 204.651 284.809)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 162.968,
  y: 305.288,
  width: 128.357,
  height: 138.201,
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
  d: "M289.794 384.789L162.854 326.467L162.968 305.288H289.794V384.789Z",
  fill: "#E1F2FF"
})), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
  d: "M268.024 393.111C268.018 391.868 269.02 390.856 270.263 390.85L326.916 390.573C328.159 390.567 329.171 391.57 329.177 392.812L329.396 437.565C329.402 438.808 328.4 439.82 327.157 439.826L270.504 440.103C269.261 440.109 268.249 439.107 268.243 437.864L268.024 393.111Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
  d: "M273.541 400.188C273.535 398.945 274.537 397.933 275.78 397.927L321.469 397.704C322.712 397.698 323.724 398.7 323.73 399.943L323.872 429.034C323.878 430.276 322.876 431.289 321.633 431.295L275.944 431.518C274.701 431.524 273.689 430.522 273.683 429.279L273.541 400.188Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
  d: "M273.574 403.002V399.828C273.574 398.784 274.421 397.938 275.465 397.938L321.874 397.712C322.918 397.712 323.764 398.557 323.764 399.601V402.718L273.574 403.002Z",
  fill: "#9ACDED",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
  d: "M323.878 426.334V429.376C323.878 430.419 323.031 431.265 321.987 431.265L275.578 431.492C274.534 431.492 273.688 430.646 273.688 429.603V426.353L323.878 426.334Z",
  fill: "#9ACDED",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
  d: "M303.858 411.881L298.395 408.745C297.639 408.304 296.705 408.302 295.947 408.739C295.189 409.177 294.724 409.986 294.728 410.861V417.152C294.724 418.027 295.189 418.837 295.947 419.274C296.705 419.711 297.639 419.709 298.395 419.268L303.84 416.113C304.601 415.683 305.074 414.877 305.078 414.003C305.081 413.128 304.616 412.319 303.858 411.881Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
  d: "M194.074 386.293C193.749 385.094 194.458 383.858 195.658 383.533L257.401 366.813C258.601 366.489 259.836 367.197 260.161 368.397L274.541 421.44C274.867 422.64 274.158 423.876 272.958 424.2L211.215 440.92C210.015 441.244 208.78 440.536 208.455 439.337L194.074 386.293Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
  d: "M202.105 392.374C201.779 391.175 202.488 389.939 203.688 389.614L253.59 376.101C254.789 375.776 256.025 376.485 256.35 377.684L265.015 409.648C265.34 410.847 264.631 412.083 263.432 412.408L213.53 425.921C212.331 426.245 211.095 425.537 210.77 424.338L202.105 392.374Z",
  fill: "#E1F2FF",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
  d: "M209.736 420.364C209.736 420.043 214.745 412.694 217.524 408.764C218.519 407.341 220.393 406.838 221.967 407.574L230.833 411.692C231.311 411.914 231.879 411.744 232.156 411.296L240.965 397.183C241.849 395.774 243.586 395.156 245.162 395.69L262.95 401.792L264.841 408.499C265.043 409.251 264.937 410.052 264.547 410.726C264.156 411.399 263.514 411.89 262.761 412.089L213.271 425.314C212.658 425.477 212.004 425.379 211.467 425.042C210.929 424.706 210.556 424.161 210.435 423.538L209.736 420.364Z",
  fill: "#9ACDED"
})), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.85362,
  ry: 3.85167,
  transform: "matrix(0.965911 -0.258875 0.258929 0.965896 250.097 387.241)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2.00848
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 98.6756,
  y: 305.439,
  width: 64.1787,
  height: 138.201,
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
  d: "M100.112 354.655L161.455 326.467L161.342 305.288H98.6756L100.112 354.655Z",
  fill: "#E1F2FF"
})), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
  d: "M162.854 305.439H98.6756L63.5144 347.494H127.674L162.854 305.439Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
  d: "M162.854 305.439H291.193L326.354 347.494H198.016L162.854 305.439Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
  d: "M114.366 386.489H144.045",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
  d: "M114.366 397.145H144.045",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
  d: "M114.366 407.8H144.045",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
  d: "M307.412 339.862H277.487",
  stroke: "#E1F2FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
  d: "M98.4488 339.862H78.7887",
  stroke: "#E1F2FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
  d: "M465.449 167.483H529.628L564.789 125.428H500.61L465.449 167.483Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
  d: "M465.449 167.483H337.091L301.93 125.428H430.288L465.449 167.483Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
  d: "M356.695 217.682V223.463",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
  d: "M359.568 220.572H353.802",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
  d: "M328.448 116.275C327.934 115.143 328.435 113.809 329.567 113.296L411.034 76.3279C412.165 75.8146 413.498 76.3152 414.012 77.4463L468.491 197.363C469.006 198.495 468.505 199.829 467.373 200.343L385.906 237.31C384.775 237.824 383.441 237.323 382.928 236.192L328.448 116.275Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
  d: "M384.124 220.931L460.231 192.592L412.65 87.8688L336.468 118.305L384.124 220.931Z",
  fill: "#E1F2FF"
})), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.0703,
  ry: 18.0634,
  transform: "matrix(0.910557 -0.413384 0.413461 0.910522 385.632 135.022)",
  fill: "white"
})), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.0703,
  ry: 18.0634,
  transform: "matrix(0.910557 -0.413384 0.41346 0.910522 386.108 130.785)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
  d: "M393.898 137.047L394.219 137.368C391.724 133.098 393.406 130.075 392.877 126.731V126.58V126.354C392.475 125.33 391.725 124.481 390.76 123.954L390.476 123.784L389.928 123.482H389.777H389.606H389.436H389.266H389.153C387.491 122.752 385.754 122.207 383.973 121.857C384.871 123.342 385.606 124.919 386.166 126.561C386.736 128.492 387.003 130.5 386.96 132.513C385.067 133.211 383.078 133.612 381.062 133.703C379.327 133.708 377.596 133.525 375.901 133.155L376.147 133.552V133.665L376.317 133.948V134.081L376.506 134.364V134.477L376.733 134.818L377.016 135.214L377.262 135.554L377.508 135.857L377.981 135.932C378.283 136.297 378.592 136.65 378.907 136.99C379.39 137.511 379.914 137.991 380.476 138.426L380.703 138.596L380.911 138.728L381.138 138.861L381.421 139.031L381.742 139.182H381.969H382.102H382.196H382.328H383.652C386.998 138.615 389.323 136.046 394.2 136.99",
  fill: "#9ACDED"
})), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
  d: "M383.954 171.319L381.081 170.242L378.113 178.101L373.236 176.268L372.158 179.14L379.89 182.05V182.031H379.928L383.954 171.319Z",
  fill: "#9ACDED"
})), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
  d: "M389.758 171.942L432.178 152.69L389.758 171.942Z",
  fill: "white"
})), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
  d: "M389.758 171.942L432.178 152.69",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
  d: "M389.871 184.373L386.998 183.297L384.049 191.156L379.153 189.323L378.075 192.195L385.807 195.086L385.826 195.067H385.845L389.871 184.373Z",
  fill: "#9ACDED"
})), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
  d: "M395.977 185.602L438.397 166.35L395.977 185.602Z",
  fill: "white"
})), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
  d: "M395.977 185.602L438.397 166.35",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
  d: "M395.807 197.41L392.934 196.333L389.966 204.192L385.088 202.359L384.011 205.231L391.743 208.141V208.103L391.78 208.122L395.807 197.41Z",
  fill: "#9ACDED"
})), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
  d: "M402.385 199.733L444.806 180.482L402.385 199.733Z",
  fill: "white"
})), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
  d: "M402.385 199.733L444.806 180.482",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
  d: "M505.242 165.462V171.243V165.462Z",
  fill: "white"
})), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
  d: "M505.242 165.462V171.243",
  stroke: "#375D81",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
  d: "M508.134 168.352H502.349H508.134Z",
  fill: "white"
})), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
  d: "M508.134 168.352H502.349",
  stroke: "#375D81",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
  d: "M456.43 84.127C456.845 82.9563 458.131 82.344 459.302 82.7593L545.117 113.198C546.288 113.613 546.901 114.9 546.485 116.071L501.646 242.339C501.23 243.51 499.944 244.122 498.773 243.707L412.958 213.269C411.787 212.853 411.174 211.567 411.59 210.396L456.43 84.127Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
  d: "M423.293 200.036L499.003 232.966L538.153 122.764L460.874 91.3073L423.293 200.036Z",
  fill: "#E1F2FF"
})), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.296,
  ry: 18.3044,
  transform: "matrix(0.331277 -0.943533 0.943557 0.331212 482.542 138.687)",
  fill: "white"
})), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.365,
  ry: 18.3734,
  transform: "matrix(0.334498 -0.942396 0.94242 0.334432 488.419 135.469)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
  d: "M489.684 145.53C489.684 145.775 489.684 145.945 489.684 146.002C490.875 141.109 494.239 140.089 496.224 137.274V137.122L496.338 136.915C496.762 135.881 496.809 134.73 496.47 133.665V133.344L496.281 132.739V132.569V132.399V132.229V132.059V131.927C495.579 130.223 494.691 128.601 493.635 127.09C493.242 128.81 492.665 130.482 491.914 132.078C490.965 133.892 489.74 135.549 488.285 136.99C486.412 136.165 484.678 135.056 483.143 133.703C481.865 132.483 480.724 131.127 479.74 129.66L479.627 130.113V130.245V130.567V130.718V131.058V131.19V131.606V132.097V132.532V132.928C479.627 133.079 479.627 133.231 479.627 133.382C479.627 133.86 479.627 134.333 479.627 134.799C479.612 135.519 479.656 136.239 479.759 136.952V137.236V137.481V137.746L479.854 138.067L479.986 138.407L480.08 138.634V138.766V138.879V138.993V139.087L480.194 139.182L480.364 139.314H480.459C483.313 141.203 486.848 141.033 489.721 145.152",
  fill: "#9452BA"
})), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
  d: "M458.19 163.591L456.848 160.776L449.135 164.442L446.866 159.662L444.05 161.003L447.66 168.579L447.679 168.56L447.698 168.598L458.19 163.591Z",
  fill: "#9ACDED"
})), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
  d: "M462.027 168.145L506.659 183.977L462.027 168.145Z",
  fill: "white"
})), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
  d: "M462.027 168.145L506.659 183.977",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
  d: "M453.313 177.326L451.989 174.511L444.258 178.177L441.989 173.378L439.172 174.719L442.783 182.314L442.802 182.295L442.821 182.314L453.313 177.326Z",
  fill: "#9ACDED"
})), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
  d: "M456.923 182.522L501.555 198.354L456.923 182.522Z",
  fill: "white"
})), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
  d: "M456.923 182.522L501.555 198.354",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
  d: "M448.454 191.043L447.112 188.228L439.399 191.912L437.112 187.113L434.295 188.454L437.906 196.03H437.925L437.944 196.049L448.454 191.043Z",
  fill: "#9ACDED"
})), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
  d: "M451.63 197.391L496.281 213.223L451.63 197.391Z",
  fill: "white"
})), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
  d: "M451.63 197.391L496.281 213.223",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
  d: "M433.303 94.3525C433.725 93.184 435.014 92.5784 436.183 92.9999L527.011 125.753C528.18 126.174 528.786 127.464 528.364 128.633L480.156 262.165C479.735 263.333 478.445 263.939 477.277 263.517L386.448 230.765C385.279 230.343 384.673 229.053 385.095 227.884L433.303 94.3525Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
  d: "M397.527 216.907L477.415 252.161L519.419 135.838L437.887 102.133L397.527 216.907Z",
  fill: "#E1F2FF"
})), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 19.4232,
  ry: 19.4319,
  transform: "matrix(0.339428 -0.940632 0.940656 0.339361 463.163 151.843)",
  fill: "white"
})), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 19.4232,
  ry: 19.4319,
  transform: "matrix(0.339428 -0.940632 0.940656 0.339361 466.715 148.957)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
  d: "M468.039 159.624C468.039 159.888 468.039 160.058 468.039 160.115C469.324 154.957 472.897 153.899 474.995 150.914V150.763L475.128 150.555C475.588 149.465 475.648 148.247 475.298 147.117V146.777C475.298 146.569 475.184 146.342 475.109 146.134V145.964V145.775V145.586V145.398V145.265C474.38 143.456 473.454 141.733 472.349 140.126C471.91 141.946 471.276 143.714 470.458 145.398C469.47 147.306 468.195 149.052 466.678 150.574C464.699 149.689 462.869 148.504 461.252 147.06C459.798 145.758 458.498 144.293 457.377 142.696L457.263 143.187V143.338V143.678V143.848V144.207V144.358V144.793V145.303V145.757V146.172C457.263 146.342 457.263 146.493 457.263 146.644C457.263 147.161 457.263 147.658 457.263 148.137C457.245 148.901 457.289 149.666 457.396 150.423V150.725V150.99V151.254L457.49 151.594L457.623 151.953L457.736 152.199V152.293V152.426V152.52V152.633V152.747V152.86L457.849 152.974L458.039 153.125H458.152C461.158 155.203 464.901 155.014 467.906 159.34",
  fill: "#9452BA"
})), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
  d: "M434.635 178.573L433.237 175.588L425.07 179.424L422.669 174.341L419.683 175.739L423.463 183.788L423.482 183.769L423.501 183.788L434.635 178.573Z",
  fill: "#9ACDED"
})), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
  d: "M438.662 183.391L485.789 200.395L438.662 183.391Z",
  fill: "white"
})), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
  d: "M438.662 183.391L485.789 200.395",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
  d: "M429.418 193.045L428.019 190.079L419.834 193.914L417.452 188.832L414.465 190.23L418.227 198.26H418.265V198.279L429.418 193.045Z",
  fill: "#9ACDED"
})), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
  d: "M433.18 198.581L480.307 215.584L433.18 198.581Z",
  fill: "white"
})), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
  d: "M433.18 198.581L480.307 215.584",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
  d: "M424.182 207.536L422.783 204.551L414.597 208.405L412.216 203.323L409.229 204.721L413.009 212.751H413.028L413.047 212.769L424.182 207.536Z",
  fill: "#9ACDED"
})), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
  d: "M427.509 214.281L474.636 231.266L427.509 214.281Z",
  fill: "white"
})), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
  d: "M427.509 214.281L474.636 231.266",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
  d: "M465.6 100.149C471.271 81.1052 514.297 36.1402 514.297 36.1402",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M470.402 84.4681L503.257 136.556C504.727 138.831 505.224 141.601 504.637 144.245L480.062 249.289C479.826 250.379 478.752 251.072 477.661 250.839L381.761 228.507C381.22 228.412 380.74 228.1 380.434 227.644C380.127 227.188 380.019 226.626 380.136 226.089L404.711 121.007C405.328 118.371 406.975 116.092 409.285 114.678L461.781 82.4654C464.719 80.6611 468.562 81.5539 470.402 84.4681ZM452.529 105.873C451.527 110.231 454.246 114.577 458.606 115.585C460.707 116.07 462.915 115.699 464.742 114.554C466.568 113.409 467.864 111.584 468.341 109.482C469.332 105.121 466.601 100.782 462.238 99.7864C457.876 98.7906 453.531 101.514 452.529 105.873Z",
  fill: "white"
})), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
  d: "M503.257 136.556L502.411 137.089L502.417 137.098L503.257 136.556ZM470.402 84.4681L471.247 83.9346L471.247 83.9342L470.402 84.4681ZM504.637 144.245L505.61 144.473L505.613 144.462L504.637 144.245ZM480.062 249.289L479.088 249.062L479.086 249.07L479.084 249.078L480.062 249.289ZM477.661 250.839L477.434 251.812L477.443 251.815L477.451 251.816L477.661 250.839ZM381.761 228.507L381.988 227.533L381.962 227.527L381.935 227.522L381.761 228.507ZM380.434 227.644L381.264 227.086L380.434 227.644ZM380.136 226.089L379.162 225.861L379.16 225.869L379.158 225.877L380.136 226.089ZM404.711 121.007L403.737 120.779L403.737 120.779L404.711 121.007ZM409.285 114.678L409.807 115.531L409.808 115.53L409.285 114.678ZM461.781 82.4654L462.304 83.3178L462.305 83.3175L461.781 82.4654ZM458.606 115.585L458.38 116.559L458.606 115.585ZM452.529 105.873L453.503 106.097V106.097L452.529 105.873ZM464.742 114.554L465.273 115.402L464.742 114.554ZM468.341 109.482L469.316 109.704L468.341 109.482ZM462.238 99.7864L462.461 98.8115L462.238 99.7864ZM504.102 136.022L471.247 83.9346L469.556 85.0016L502.411 137.089L504.102 136.022ZM505.613 144.462C506.258 141.556 505.712 138.513 504.096 136.013L502.417 137.098C503.742 139.149 504.19 141.645 503.66 144.028L505.613 144.462ZM481.035 249.517L505.61 144.473L503.663 144.017L479.088 249.062L481.035 249.517ZM477.451 251.816C479.081 252.165 480.686 251.13 481.039 249.501L479.084 249.078C478.965 249.628 478.422 249.979 477.87 249.861L477.451 251.816ZM381.535 229.481L477.434 251.812L477.888 249.865L381.988 227.533L381.535 229.481ZM379.604 228.202C380.062 228.884 380.779 229.349 381.588 229.492L381.935 227.522C381.661 227.474 381.419 227.316 381.264 227.086L379.604 228.202ZM379.158 225.877C378.984 226.68 379.145 227.52 379.604 228.202L381.264 227.086C381.109 226.855 381.054 226.572 381.113 226.3L379.158 225.877ZM403.737 120.779L379.162 225.861L381.109 226.317L405.684 121.235L403.737 120.779ZM408.763 113.825C406.225 115.378 404.415 117.882 403.737 120.779L405.684 121.235C406.24 118.859 407.725 116.805 409.807 115.531L408.763 113.825ZM461.258 81.6131L408.762 113.825L409.808 115.53L462.304 83.3178L461.258 81.6131ZM471.247 83.9342C469.115 80.5569 464.662 79.5226 461.258 81.6134L462.305 83.3175C464.776 81.7996 468.009 82.5509 469.556 85.0019L471.247 83.9342ZM458.831 114.61C455.008 113.727 452.625 109.917 453.503 106.097L451.554 105.648C450.428 110.545 453.484 115.427 458.38 116.559L458.831 114.61ZM464.21 113.707C462.609 114.711 460.673 115.036 458.831 114.61L458.38 116.559C460.74 117.104 463.221 116.688 465.273 115.402L464.21 113.707ZM467.366 109.261C466.948 111.103 465.812 112.703 464.21 113.707L465.273 115.402C467.325 114.115 468.78 112.065 469.316 109.704L467.366 109.261ZM462.016 100.761C465.841 101.634 468.234 105.438 467.366 109.261L469.316 109.704C470.429 104.804 467.361 99.93 462.461 98.8115L462.016 100.761ZM453.503 106.097C454.382 102.276 458.191 99.8881 462.016 100.761L462.461 98.8115C457.561 97.693 452.68 100.752 451.554 105.648L453.503 106.097Z",
  fill: "#9ACDED"
})), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
  d: "M412.991 126.184L392.707 220.648L470.024 240.202L494.807 141.468L474.39 108.046L471.801 117.247C470.472 121.958 465.931 125.018 461.063 124.483C451.617 123.435 443.376 117.603 439.248 109.048L412.991 126.184Z",
  fill: "#E1F2FF"
})), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 25.0338,
  ry: 25.0469,
  transform: "matrix(0.226845 -0.973931 0.973942 0.226797 445.221 162.719)",
  fill: "#EFEFF6"
})), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 25.0338,
  ry: 25.0469,
  transform: "matrix(0.226845 -0.973931 0.973942 0.226797 449.325 158.48)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
  d: "M452.632 171.942C452.632 172.263 452.632 172.49 452.632 172.565C453.502 165.764 457.906 163.875 460.194 159.737V159.529L460.326 159.246C460.748 157.783 460.641 156.217 460.023 154.825L459.872 154.391L459.532 153.597L459.419 153.37L459.305 153.144L459.192 152.917L459.078 152.69V152.52C457.871 150.316 456.426 148.25 454.768 146.361C454.497 148.747 453.971 151.097 453.199 153.37C452.193 155.976 450.79 158.41 449.04 160.587C446.345 159.765 443.794 158.529 441.479 156.922C439.558 155.468 437.802 153.808 436.242 151.972V152.615V152.804C436.242 152.955 436.242 153.106 436.242 153.257V153.465V153.918V154.107C436.242 154.296 436.242 154.485 436.242 154.693C436.242 154.92 436.242 155.146 436.242 155.354C436.242 155.562 436.242 155.751 436.242 155.959V156.072C436.242 156.261 436.242 156.431 436.242 156.62C436.242 156.809 436.242 156.62 436.242 156.733C436.242 156.847 436.242 157.149 436.242 157.357C436.242 158.024 436.286 158.654 436.375 159.246C436.472 160.222 436.649 161.189 436.904 162.137L437.017 162.514L437.131 162.836L437.263 163.176L437.433 163.591L437.66 164.026L437.83 164.309V164.423L437.944 164.593V164.706L438.057 164.857V164.971L438.171 165.103L438.265 165.197L438.397 165.329L438.568 165.443L438.813 165.594L438.964 165.688C443.123 167.899 447.887 167.049 452.405 172.188",
  fill: "#9ACDED"
})), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
  d: "M410.382 198.184L465.335 210.994",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
  d: "M406.998 212.694L461.952 225.484",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
  d: "M507.661 32.6072C507.661 32.6072 507.661 42.0536 505.62 45.8322C501.461 53.276 495.563 61.2866 491.234 73.6614C483.559 95.596 480.742 115.736 467.604 108.027C465.846 106.988 464.069 103.474 465.317 101.302",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M502.122 50.102C502.122 50.102 507.283 50.7066 508.361 48.6472C509.438 46.5879 498.209 41.4679 502.122 50.102Z",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
  d: "M376.093 149.289C376.55 148.134 377.857 147.568 379.012 148.024L454.196 177.744C455.352 178.201 455.918 179.508 455.461 180.664L418.973 272.861C418.516 274.016 417.209 274.582 416.054 274.125L340.87 244.406C339.715 243.949 339.148 242.641 339.606 241.486L376.093 149.289Z",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
  d: "M417.093 261.702L347.092 238.653L379.285 157.262L449.57 181.955L417.093 261.702Z",
  fill: "#E1F2FF"
})), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 13.7362,
  ry: 16.4073,
  transform: "matrix(0.367836 -0.929891 0.929919 0.367764 402.39 192.389)",
  fill: "white"
})), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 13.7362,
  ry: 16.4073,
  transform: "matrix(0.367836 -0.929891 0.929919 0.367764 405.242 190.523)",
  fill: "white",
  stroke: "#9ACDED",
  strokeWidth: 2
})), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
  d: "M406.525 198.279C406.525 198.468 406.525 198.6 406.525 198.638C407.471 194.991 410.401 194.462 412.083 192.46V192.346L412.178 192.195C412.513 191.404 412.513 190.511 412.178 189.72V189.475L412.008 189.002V188.87V188.738V188.606V188.473V188.379C411.348 186.994 410.543 185.683 409.607 184.468C409.301 185.784 408.825 187.054 408.189 188.247C407.377 189.585 406.334 190.768 405.108 191.742C403.469 190.974 401.937 189.996 400.552 188.832C399.429 187.814 398.409 186.688 397.508 185.469V185.809V185.904V186.149V186.263V186.508V186.603V186.924V187.283V187.604V187.906C397.508 188.02 397.508 188.133 397.508 188.247C397.508 188.612 397.508 188.971 397.508 189.323C397.514 189.882 397.571 190.438 397.678 190.986V191.213V191.402V191.609V191.855L397.792 192.12V192.29V192.384H397.886L398.038 192.497C400.571 194.217 403.709 194.387 406.242 197.674",
  fill: "#9ACDED"
})), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
  d: "M379.323 209.747L378.094 207.498L371.421 209.709L369.341 205.855L366.903 206.667L370.192 212.751H370.211L370.23 212.769L379.323 209.747Z",
  fill: "#9ACDED"
})), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
  d: "M383.009 213.846L422.367 229.395L383.009 213.846Z",
  fill: "white"
})), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
  d: "M383.009 213.846L422.367 229.395",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
  d: "M375.315 219.892L374.086 217.625L367.413 219.854L365.334 216L362.876 216.813L366.185 222.896H366.203H366.222L375.315 219.892Z",
  fill: "#9ACDED"
})), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
  d: "M378.548 224.143L417.906 239.692L378.548 224.143Z",
  fill: "white"
})), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
  d: "M378.548 224.143L417.906 239.692",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
  d: "M371.307 230.019L370.079 227.77L363.406 229.981L361.307 226.146L358.869 226.939L362.177 233.023H362.196L362.215 233.041L371.307 230.019Z",
  fill: "#9ACDED"
})), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
  d: "M374.219 235.12L413.558 250.687L374.219 235.12Z",
  fill: "white"
})), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
  d: "M374.219 235.12L413.558 250.687",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 401.384,
  y: 167.332,
  width: 128.357,
  height: 138.201,
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
  d: "M528.21 246.833L401.27 207.593L401.384 167.332H528.21V246.833Z",
  fill: "#E1F2FF"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 337.091,
  y: 167.483,
  width: 64.1787,
  height: 138.201,
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
  d: "M338.528 216.699L399.89 207.593L399.758 167.332H337.091L338.528 216.699Z",
  fill: "#E1F2FF"
})), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 464.504,
  cy: 250.593,
  rx: 25.8794,
  ry: 25.8643,
  fill: "#EFEFF6"
})), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 470.61,
  cy: 245.719,
  rx: 25.8794,
  ry: 25.8643,
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
  d: "M478.908 258.736C479.022 259.076 479.116 259.303 479.154 259.378C478.398 252.029 482.576 248.949 483.918 244.075C483.912 243.993 483.912 243.911 483.918 243.829C483.924 243.716 483.924 243.603 483.918 243.489C484.004 241.848 483.509 240.229 482.519 238.917L482.254 238.502L481.706 237.746L481.536 237.538L481.366 237.33L481.196 237.122L481.026 236.915L480.893 236.763C479.087 234.747 477.065 232.935 474.863 231.36C475.14 233.935 475.14 236.532 474.863 239.106C474.448 242.088 473.574 244.987 472.273 247.702C469.269 247.483 466.317 246.801 463.521 245.681C461.147 244.619 458.897 243.302 456.81 241.751V242.431V242.639C456.81 242.809 456.81 242.96 456.81 243.13V243.357V243.848V244.056L456.923 244.679L457.056 245.397L457.188 246.021V246.153L457.32 246.72V246.833L457.49 247.476C457.679 248.168 457.881 248.836 458.095 249.478C458.431 250.48 458.848 251.454 459.343 252.388L459.551 252.747L459.74 253.068L459.948 253.389L460.231 253.786L460.572 254.183L460.817 254.447L460.931 254.542L461.082 254.693L461.195 254.787L461.347 254.901H461.479L461.63 255.014H461.763L461.933 255.108H462.046H462.254H462.349L462.651 255.203H462.84C467.755 256.506 472.538 254.447 478.549 258.736",
  fill: "#F9B53F"
})), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
  d: "M352.782 248.534H382.48",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
  d: "M352.782 259.189H382.48",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
  d: "M352.782 269.845H382.48",
  stroke: "#9ACDED",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
  d: "M401.27 167.483H337.091L301.93 209.539H366.109L401.27 167.483Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
  d: "M401.27 167.483H529.628L564.789 209.539H436.431L401.27 167.483Z",
  fill: "white",
  stroke: "#375D81",
  strokeWidth: 2
})), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
  d: "M545.828 201.906H515.903",
  stroke: "#E1F2FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
  d: "M336.884 201.906H317.223",
  stroke: "#E1F2FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0448 309.425V315.207",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9371 312.316H12.1714",
  stroke: "#375D81",
  strokeLinecap: "round"
})), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
  d: "M719.895 213.412L741.408 188.757L719.895 213.412Z",
  fill: "white"
})), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
  d: "M719.895 213.412L741.408 188.757",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: 10
})), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
  d: "M730.878 227.978L754.886 214.923L730.878 227.978Z",
  fill: "white"
})), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
  d: "M730.878 227.978L754.886 214.923",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: 5
})), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
  d: "M701.256 201.812L712.806 175.532L701.256 201.812Z",
  fill: "white"
})), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
  d: "M701.256 201.812L712.806 175.532",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: 10
})), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
  d: "M34.3646 443.489H806.532H34.3646Z",
  fill: "white"
})), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
  d: "M34.3646 443.489H806.532",
  stroke: "#375D81",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M370.929 374.813L370.495 377.572H367.3L366.978 374.492C366.903 373.9 366.988 373.381 367.234 372.934C367.479 372.486 367.807 372.077 368.217 371.706C368.626 371.334 369.083 370.975 369.587 370.629C370.091 370.282 370.564 369.904 371.005 369.495C371.446 369.086 371.815 368.626 372.111 368.116C372.407 367.606 372.555 366.998 372.555 366.293C372.555 365.839 372.47 365.433 372.3 365.074C372.13 364.715 371.894 364.407 371.591 364.148C371.289 363.89 370.926 363.692 370.504 363.553C370.082 363.415 369.625 363.345 369.134 363.345C368.415 363.345 367.807 363.424 367.309 363.582C366.812 363.739 366.389 363.915 366.043 364.111C365.696 364.306 365.403 364.482 365.164 364.64C364.924 364.797 364.71 364.876 364.521 364.876C364.067 364.876 363.74 364.687 363.538 364.309L362.309 362.363C362.738 361.985 363.207 361.626 363.718 361.286C364.228 360.946 364.779 360.65 365.372 360.398C365.964 360.146 366.607 359.948 367.3 359.803C367.993 359.658 368.743 359.586 369.549 359.586C370.646 359.586 371.645 359.737 372.546 360.039C373.447 360.341 374.219 360.773 374.861 361.333C375.504 361.894 376.002 362.571 376.355 363.364C376.708 364.158 376.884 365.046 376.884 366.028C376.884 366.985 376.745 367.814 376.468 368.513C376.191 369.212 375.844 369.819 375.429 370.336C375.013 370.852 374.556 371.299 374.058 371.677C373.56 372.055 373.091 372.411 372.65 372.745C372.209 373.078 371.827 373.406 371.506 373.727C371.185 374.048 370.992 374.41 370.929 374.813ZM369.861 387.254C369.515 387.399 369.14 387.472 368.737 387.472C368.333 387.472 367.955 387.399 367.602 387.254C367.249 387.11 366.947 386.911 366.695 386.659C366.443 386.407 366.244 386.108 366.099 385.762C365.955 385.415 365.882 385.041 365.882 384.638C365.882 384.247 365.955 383.876 366.099 383.523C366.244 383.17 366.443 382.868 366.695 382.616C366.947 382.364 367.249 382.163 367.602 382.012C367.955 381.86 368.333 381.785 368.737 381.785C369.14 381.785 369.515 381.86 369.861 382.012C370.208 382.163 370.51 382.364 370.769 382.616C371.027 382.868 371.232 383.17 371.383 383.523C371.534 383.876 371.61 384.247 371.61 384.638C371.61 385.041 371.534 385.415 371.383 385.762C371.232 386.108 371.027 386.407 370.769 386.659C370.51 386.911 370.208 387.11 369.861 387.254Z",
  fill: "#375D81"
})), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M826.144 400.56C827.04 400.56 827.858 400.408 828.598 400.105C829.338 399.802 829.972 399.375 830.499 398.825C831.026 398.276 831.435 397.619 831.724 396.857C832.013 396.095 832.158 395.257 832.158 394.345C832.158 393.432 832.013 392.595 831.724 391.833C831.435 391.07 831.026 390.413 830.499 389.86C829.972 389.308 829.338 388.878 828.598 388.572C827.858 388.266 827.04 388.113 826.144 388.113C825.248 388.113 824.431 388.266 823.694 388.572C822.956 388.878 822.324 389.308 821.797 389.86C821.269 390.413 820.861 391.07 820.572 391.833C820.282 392.595 820.138 393.432 820.138 394.345C820.138 395.257 820.282 396.095 820.572 396.857C820.861 397.619 821.269 398.276 821.797 398.825C822.324 399.375 822.956 399.802 823.694 400.105C824.431 400.408 825.248 400.56 826.144 400.56ZM797.263 400.432L797.272 399.089H791.402V394.932H796.149V393.639H791.402V389.592H797.263V388.249H789.752V400.432H797.263ZM801.219 400.432V395.348H802.469C802.702 395.348 802.873 395.378 802.984 395.437C803.095 395.497 803.198 395.595 803.294 395.731L806.459 400.084C806.601 400.316 806.822 400.432 807.122 400.432H808.586L805.03 395.595C804.877 395.368 804.695 395.195 804.485 395.076C804.956 394.968 805.377 394.81 805.749 394.6C806.12 394.39 806.435 394.137 806.693 393.839C806.951 393.541 807.148 393.206 807.284 392.832C807.42 392.457 807.488 392.055 807.488 391.624C807.488 391.109 807.4 390.642 807.225 390.226C807.049 389.809 806.778 389.454 806.412 389.159C806.046 388.864 805.583 388.639 805.021 388.483C804.46 388.327 803.794 388.249 803.022 388.249H799.577V400.432H801.219ZM801.219 394.149H802.954C803.431 394.149 803.852 394.091 804.217 393.975C804.583 393.859 804.889 393.695 805.136 393.482C805.383 393.269 805.569 393.016 805.693 392.721C805.818 392.426 805.881 392.1 805.881 391.743C805.881 391.018 805.642 390.471 805.166 390.103C804.69 389.734 803.975 389.55 803.022 389.55H801.219V394.149ZM811.878 400.432V395.348H813.128C813.361 395.348 813.532 395.378 813.643 395.437C813.753 395.497 813.857 395.595 813.953 395.731L817.118 400.084C817.26 400.316 817.481 400.432 817.781 400.432H819.245L815.689 395.595C815.536 395.368 815.354 395.195 815.144 395.076C815.615 394.968 816.036 394.81 816.408 394.6C816.779 394.39 817.094 394.137 817.352 393.839C817.61 393.541 817.807 393.206 817.943 392.832C818.079 392.457 818.147 392.055 818.147 391.624C818.147 391.109 818.059 390.642 817.884 390.226C817.708 389.809 817.437 389.454 817.071 389.159C816.705 388.864 816.242 388.639 815.68 388.483C815.119 388.327 814.452 388.249 813.681 388.249H810.236V400.432H811.878ZM811.878 394.149H813.613C814.09 394.149 814.511 394.091 814.876 393.975C815.242 393.859 815.548 393.695 815.795 393.482C816.042 393.269 816.228 393.016 816.352 392.721C816.477 392.426 816.539 392.1 816.539 391.743C816.539 391.018 816.301 390.471 815.825 390.103C815.349 389.734 814.634 389.55 813.681 389.55H811.878V394.149ZM824.366 398.804C824.899 399.022 825.491 399.131 826.144 399.131C826.801 399.131 827.397 399.022 827.93 398.804C828.463 398.586 828.917 398.271 829.291 397.86C829.665 397.449 829.955 396.948 830.159 396.356C830.363 395.763 830.465 395.093 830.465 394.345C830.465 393.597 830.363 392.925 830.159 392.33C829.955 391.735 829.665 391.232 829.291 390.821C828.917 390.41 828.463 390.094 827.93 389.873C827.397 389.652 826.801 389.541 826.144 389.541C825.491 389.541 824.899 389.652 824.366 389.873C823.833 390.094 823.377 390.41 823 390.821C822.623 391.232 822.333 391.735 822.128 392.33C821.924 392.925 821.822 393.597 821.822 394.345C821.822 395.093 821.924 395.763 822.128 396.356C822.333 396.948 822.623 397.449 823 397.86C823.377 398.271 823.833 398.586 824.366 398.804ZM836.156 400.432V395.348H837.407C837.639 395.348 837.811 395.378 837.921 395.437C838.032 395.497 838.135 395.595 838.232 395.731L841.396 400.084C841.538 400.316 841.759 400.432 842.06 400.432H843.523L839.967 395.595C839.814 395.368 839.632 395.195 839.423 395.076C839.893 394.968 840.314 394.81 840.686 394.6C841.057 394.39 841.372 394.137 841.63 393.839C841.888 393.541 842.085 393.206 842.221 392.832C842.357 392.457 842.425 392.055 842.425 391.624C842.425 391.109 842.338 390.642 842.162 390.226C841.986 389.809 841.715 389.454 841.349 389.159C840.984 388.864 840.52 388.639 839.959 388.483C839.397 388.327 838.731 388.249 837.959 388.249H834.514V400.432H836.156ZM836.156 394.149H837.891C838.368 394.149 838.789 394.091 839.155 393.975C839.52 393.859 839.827 393.695 840.073 393.482C840.32 393.269 840.506 393.016 840.631 392.721C840.755 392.426 840.818 392.1 840.818 391.743C840.818 391.018 840.58 390.471 840.103 390.103C839.627 389.734 838.912 389.55 837.959 389.55H836.156V394.149Z",
  fill: "#375D81"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgError404);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Error404.7e9f433f0afeb98a357974b4513b172d.svg";